import { render, staticRenderFns } from "./VAttributeValue.vue?vue&type=template&id=0267a1b0"
import script from "./VAttributeValue.vue?vue&type=script&lang=js"
export * from "./VAttributeValue.vue?vue&type=script&lang=js"
import style0 from "./VAttributeValue.vue?vue&type=style&index=0&id=0267a1b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports